import { Reflection } from './reflection';
import { ReflectionSubmitResponseDto } from './reflection-submit-response.dto';

export class ReflectionSubmitResponse extends Reflection {
    readonly moduleIds: string[];
    readonly courseIds: string[];
    readonly pathwayIds: string[];

    constructor(dto: ReflectionSubmitResponseDto) {
        super(dto);

        this.moduleIds = dto.moduleIds;
        this.courseIds = dto.courseIds;
        this.pathwayIds = dto.pathwayIds;
    }
}
